<template>
  <div>
    <router-link :to="{name: 'bundle-create' }" class="button is-primary is-pulled-right">
      Add bundle
    </router-link>

    <data-table :data-set="bundles" :page-length="50" :columns="[
            {name: 'i', type: 'text', prop: 'name', searchable: false},
            {name: 'Name', type: 'text', prop: 'name'},
            {name: 'Company', type: 'text', prop: 'company'},
            {name: 'Updated', type: 'date', prop: 'updated_at', filter: ['moment', ['from', 'now']]},
            {name: 'Created', type: 'date', prop: 'created_at', filter: ['moment', ['from', 'now']]},
        ]">
      <template slot="column_i" slot-scope="props">
        <router-link :to="{name: 'bundle', params: {id: props.row.id}}">
          <div class="data-images">
            <img v-if="props.row.image !== null" :src="props.row.image.thumbnail_path" class="data-image" />
          </div>
        </router-link>
      </template>
      <template slot="column_Name" slot-scope="props">
        <router-link :to="{name: 'bundle', params: {id: props.row.id}}">
          {{ props.row.name }}
        </router-link>
      </template>
      <template slot="column_Company" slot-scope="props">
        {{ props.row.company !== null ? 'Show on ' + props.row.company + ' ONLY)' : '' }}
      </template>
      <template slot="controls" slot-scope="props">
        <td>
          <div class="has-text-right">
            <a class="delete" @click="deleteBundle(props.row)"></a>
          </div>
        </td>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DELETE_BUNDLE } from "../../../store/mutation-types";

export default {
  name: 'bundle-list',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['bundles', 'images']), sortedBundles() {
      return this.bundles.map(b => {
        return { ...b, image: this.images.find(i => i.id === b.image_id) }
      });
    },
  },
  methods: {
    deleteBundle(bundle) {
      this.$store.dispatch(DELETE_BUNDLE, bundle)
    },
  },
}
</script>



// WEBPACK FOOTER //
// BundleList.vue?1fd18ff7